export default __webpack_public_path__ + "static/media/tulsa-img.42773c43.png";